<template>
  <div v-if="showCapacity" class="capacity-reservation">
    <div :class="['capacity-reservation__bar']">
      <span :class="['capacity-reservation__label']">Capacity</span>

      <div
        :class="[
          'capacity-reservation__row',
          'capacity-reservation__capacity',
          isCapacityReserved && 'capacity-reservation__capacity--success'
        ]"
      >
        <img v-if="isCapacityReserved" :src="CapacitySuccessIcon" alt="Capacity Reserved" />
        <img v-else :src="CapacityWarningIcon" alt="Capacity On-demand" />

        <span>{{ capacityLabel }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { IWorkspaceAsset, Service, WorkspaceTemplate } from "@/types/workspace"
import { computed, defineComponent, PropType } from "@vue/composition-api"
import { createTranslationModule } from "@/plugins/i18n"
import CapacitySuccessIcon from "@/assets/cloud-success.svg"
import CapacityWarningIcon from "@/assets/cloud-warning.svg"
import "../../scss/_capacity-reservation.scss"

export default defineComponent({
  name: "CapacityReservation",
  props: {
    app: {
      type: Object as PropType<IWorkspaceAsset | Service>,
      required: true
    },
    workspace: {
      type: Object as PropType<WorkspaceTemplate>,
      required: true
    }
  },
  setup(props) {
    const t = createTranslationModule("WorkspaceEdit.appCard.footer.capacityReservation")

    const isService = computed(() => {
      return props.app._discriminator === "service"
    })

    const showCapacity = computed(() => {
      return !isService.value
    })

    const isCapacityReserved = computed(() => {
      const app = props.app as IWorkspaceAsset
      const reservation = app?.capacityReservation

      if (reservation) {
        return typeof reservation.endDate === "string"
      }

      return false
    })

    const capacityLabel = computed(() => {
      return isCapacityReserved.value ? t("reserved") : t("onDemand")
    })

    return {
      capacityLabel,
      isCapacityReserved,
      showCapacity,
      CapacitySuccessIcon,
      CapacityWarningIcon
    }
  }
})
</script>
